import contextMenu from 'helpers/styles/contextMenu'

export default {
  ...contextMenu
}



// WEBPACK FOOTER //
// ./src/components/WiredDevice/style.js